'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactI18next = require('react-i18next');

var _publishErrors = require('../../helpers/publishErrors');

var _publishErrors2 = _interopRequireDefault(_publishErrors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Form = (_dec = (0, _reactI18next.translate)(), _dec2 = (0, _publishErrors2.default)(), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Form, _React$Component);

  function Form() {
    (0, _classCallCheck3.default)(this, Form);
    return (0, _possibleConstructorReturn3.default)(this, (Form.__proto__ || (0, _getPrototypeOf2.default)(Form)).apply(this, arguments));
  }

  (0, _createClass3.default)(Form, [{
    key: 'onSubmit',
    value: function onSubmit(e) {
      var t = this.props.t;


      if (!Form.hasHtml5Validation()) {
        this.props.onSubmit(e);
        return;
      }

      if (e.target.checkValidity()) {
        this.props.onSubmit(e);
      } else {
        e.preventDefault();
        this.props.publishError(t('complete_all_fields'));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var formProps = (0, _assign2.default)({}, this.props);
      delete formProps.styles;
      delete formProps.onSubmit;
      delete formProps.t;
      delete formProps.publishError;
      delete formProps.i18nLoadedAt;

      return _react2.default.createElement('form', (0, _extends3.default)({}, formProps, { onSubmit: this.onSubmit.bind(this) }));
    }
  }], [{
    key: 'hasHtml5Validation',
    value: function hasHtml5Validation() {
      return typeof document.createElement('input').checkValidity === 'function';
    }
  }]);
  return Form;
}(_react2.default.Component), _class2.defaultProps = {
  onSubmit: function onSubmit() {
    return {};
  }
}, _class2.propTypes = {
  onSubmit: _react.PropTypes.func.isRequired
}, _temp)) || _class) || _class);
exports.default = Form;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/Form/index.js
// module id = 146
// module chunks = 0